var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('span',{staticStyle:{"line-height":"32px"}},[_vm._v(_vm._s(_vm.title))]),_vm._t("place",[_c('div',{staticStyle:{"margin-left":"auto"}},[_vm._t("default")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }